"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLocalInteraction = toLocalInteraction;
exports.toInteractionRecord = toInteractionRecord;

var _immutable = require("immutable");

/*
  Transforms an `InteractionRecord` to a `LocalInteraction` for local storage.
  Interactions that require more than this should write additional transforms.
*/
var KEYS = (0, _immutable.Seq)(['endTime', 'startTime', 'title', 'contactIdsToAssociate']);

function toLocalInteraction(interactionRecord, localInteraction) {
  return localInteraction.set('schedule', interactionRecord.metadata.filter(function (__, key) {
    return KEYS.includes(key);
  }));
}

function toInteractionRecord(localInteraction, interactionRecord) {
  var metadata = interactionRecord.metadata.merge(localInteraction.get('schedule'));
  return interactionRecord.set('metadata', metadata);
}